var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"purchase_title"},[_vm._v("\n    "+_vm._s(_vm.titlename)+"\n    "),(_vm.subname)?_c('span',[_c('router-link',{staticClass:"subtitle",attrs:{"to":_vm.sublink},on:{"click":_vm.goClick}},[_vm._v(_vm._s(_vm.subname))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }